import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "highlight"];
import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../../components/Base';
import { ListContext } from '../context';
var styles = {
  "root": "ListItem-root_YNj7Z",
  "highlighted": "ListItem-highlighted_4CnOB",
  "highlighted-info": "ListItem-highlighted-info_BbqJK ListItem-highlighted_4CnOB",
  "highlighted-success": "ListItem-highlighted-success_3R_YZ ListItem-highlighted_4CnOB",
  "highlighted-warning": "ListItem-highlighted-warning_3GiTH ListItem-highlighted_4CnOB",
  "highlighted-danger": "ListItem-highlighted-danger_3qccQ ListItem-highlighted_4CnOB",
  "highlighted-placeholder": "ListItem-highlighted-placeholder_3Gm00 ListItem-highlighted_4CnOB"
};
function ListItem(_ref) {
  var children = _ref.children,
    className = _ref.className,
    highlight = _ref.highlight,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var context = React.useContext(ListContext);
  var rootClasses = clsx(styles.root, highlight && styles["highlighted-".concat(highlight)], className);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      backgroundColor: context.variant === 'bordered' ? undefined : 'grey-lighter',
      className: rootClasses
    }, extraProps), children)
  );
}
export default ListItem;